module.exports = __webpack_public_path__ + "static/media/contact_05.f8e06bf7.jpg";